module.exports = __webpack_public_path__ + "static/media/BIL_grey.2251ca97.webp";